import { getSignUpUserDetail } from "./getSignupUserDetail";
import { getUserData } from "./userApis/getUser";

export const checkStaffAccess = async (): Promise<boolean> => {
  const userID = localStorage.getItem("user_id");
  const token = localStorage.getItem("token");

  if (!userID || !token) {
    return false;
  }

  try {
    const userData = await getUserData(Number(userID));
    if (userData && Object.prototype.hasOwnProperty.call(userData, "is_staff")) {
      return !!userData.is_staff;
    }
  } catch {
    // fall through to signup endpoint
  }

  try {
    const userData = await getSignUpUserDetail(userID);
    if (userData?.is_staff != null) {
      return !!userData.is_staff;
    }
  } catch {
    // fall through to the value saved at login
  }

  return localStorage.getItem("is_staff") === "true";
};
